import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  selected?: boolean
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: 24px;

  .extrato-container {
    display: flex;
  }

  .extrato-left {
    width: 369px;
    height: auto;
    max-height: 500px;

    padding: 24px 30px 34.2px 24px;

    border-radius: 10px;
    background: var(--Branco-Background-F9, #f9f9f9);

    margin-right: 64px;

    overflow-x: hidden;

    ::-webkit-scrollbar-track {
      background-color: #f4f4f4;
    }
    ::-webkit-scrollbar {
      width: 6px;
      background: #f4f4f4;
    }
    ::-webkit-scrollbar-thumb {
      background: #dad7d7;
    }
  }

  .extract-title-img {
    width: 24px;
    height: 24px;

    filter: ${Theme.icons.QUATERNARY};
  }

  .extract-title-span {
    color: #0dc143;

    font-family: 'Roboto';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px; /* 162.5% */
    letter-spacing: 0.2px;
  }

  .extract-title {
    display: flex;
    gap: 10px;

    margin-bottom: 40px;
  }

  .extract-date-container {
    display: flex;
    flex-direction: column;
    margin: 2px solid green;

    margin-bottom: 24px;
  }

  .extract-date-title {
    margin-bottom: 5px;

    color: #757575;

    font-family: 'Roboto';
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 200% */
  }

  .extrato-right {
    display: flex;
    flex-direction: column;
  }

  .extrato-right-title {
    color: #070707;

    font-family: 'Roboto';
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.2px;

    margin-bottom: 24px;
  }

  .extrato-right-subtitle {
    color: var(--cinza-6-mdio-9-e, #9e9e9e);
    font-family: 'Inter';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 142.857% */
  }

  .extrato-right-value {
    color: var(--Preto, #070707);
    font-family: 'Inter';
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 100% */
  }

  .extrato-right-origin1 {
    color: var(--Preto, #070707);
    font-family: 'Inter';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
  }

  .extrato-right-origin2 {
    color: var(--Preto, #070707);
    font-family: 'Inter';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
  }

  .extrato-right-originImg {
    width: 16px;
    height: 16px;
    margin-left: 6px;
  }

  .margin-bottom-30 {
    margin-bottom: 30px;
  }

  .margin-bottom-20 {
    margin-bottom: 20px;
  }

  .margin-bottom-16 {
    margin-bottom: 16px;
  }

  .extrato-right-label {
    color: var(--cinza-8-escuro-61-cancel, #616161);
    font-family: 'Inter';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */

    margin-right: 5px;
  }

  .extrato-right-label-value {
    color: var(--Preto, #070707);
    font-family: 'Inter';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }
`

export const CardExtract = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px !important;
  background-color: ${(props: IStyleProps) => {
    if (props.selected) return '#fdfdfd'
    return 'transparent'
  }};

  box-shadow: ${(props: IStyleProps) => {
    if (props.selected) return '1px 1px 16px 0px rgba(0, 0, 0, 0.1)'
    return ''
  }};

  border: none;

  cursor: pointer;

  padding: 0px 6px;

  width: 100%;
  height: 90px;

  .extract-date-clock {
    color: var(--cinza-7-cinza-novo-75, #757575);
    text-align: right;
    font-family: 'Inter';
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 200% */
  }

  .extract-date-info-positive-value {
    color: ${Theme.pallete.QUINARY};
    font-family: 'Inter';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .extract-date-info-negative-value {
    color: ${Theme.pallete.SENARY};
    font-family: 'Inter';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .extract-date-info-origin {
    color: var(--cinza-7-cinza-novo-75, #757575);
    font-family: 'Inter';
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 12px; /* 100% */
  }

  .extract-date-info-title {
    color: var(--cinza-7-cinza-novo-75, #757575);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: 'Inter';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 142.857% */

    white-space: nowrap;
  }

  .extract-card-img {
    width: 24px;
    height: 24px;
  }

  .extract-date-info-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    width: 176px;

    gap: 5px;
  }
`
